import React from "react";
import {connect} from "react-redux";
import {defaultDashboard} from "../reducers/authReducer";
import PickupAndSalesDashboard from "./views/pickupsAndSales/PickupAndSalesDashboard";
import ReportsDashboard from "./views/statistics/ReportsDashboard";
import WarehouseDashboard from "./views/warehouses/WarehouseDashboard";
import ConsignmentsTrackingPage from "../pages/consignmentsTracking/ConsignmentsTrackingPage";
import "./DashboardPage.scss";


const DashboardPage = (props) => {
  let dashboard = null;
  
  const noQuery = Object.keys(props.location.query).length === 0;
  const useWarehouse = props.location.query.warehouse || (noQuery && props.defaultDashboard.startsWith("warehouse:"));
  const useStatistics = props.location.query.statistics || (noQuery && props.defaultDashboard.startsWith("statistics:"));
  const useConsginmentsTracking = props.location.query.tracking || (noQuery && props.defaultDashboard.startsWith("tracking:"));

  if (useWarehouse) {
    const warehouse = props.location.query.warehouse
      ? `warehouse:${props.location.query.warehouse}`
      : props.defaultDashboard;
    dashboard = <WarehouseDashboard {...props} warehouse={warehouse} />;
  } else if (useStatistics) {
    dashboard = <ReportsDashboard />
  } else if (useConsginmentsTracking) {
    dashboard = <ConsignmentsTrackingPage {...props} />;
  } else {
    dashboard = <PickupAndSalesDashboard {...props} />;
  }

  return (
    <div className="DashboardPage">
      { dashboard }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    defaultDashboard: defaultDashboard(state.get("auth")),
  }
}

export default connect(mapStateToProps, {})(DashboardPage);